import React from "react";
import { formatDateTimeWithoutSeconds } from "../../../shared/dateTimeUtils";

export default function ObPatientInfo({
  showPHI,
  patient,
  specifics,
  children,
}) {
  return (
    <div className="patient-info">
      <div className="top">
        <div className="name">{getObPatientName(showPHI, patient)}</div>
        <span> • </span>
        <div className="age">{patient.age}</div>
      </div>
      <div className="location">
        <ObPatientLocation
          mrn={patient.mrn}
          unit={specifics.unit}
          bed={specifics.location}
        />
      </div>
      <div className="status">
        <ObPatientStatus specifics={specifics} />
        {children}
      </div>
    </div>
  );
}

export function getObPatientName(showPHI, patient) {
  return showPHI
    ? `${patient.lastName}, ${patient.firstName}`
    : `${patient.lastName.slice(0, 3)}, ${patient.firstName.slice(0, 3)}`;
}

export function ObPatientLocation({ mrn, unit, bed }) {
  return (
    <span>
      {mrn ? <span>{mrn} • </span> : null}
      {unit ? <span>{unit} • </span> : null}
      {bed}
    </span>
  );
}

export function ObPatientStatus({ specifics }) {
  let gp = `G${specifics.gravida || "--"}P${specifics.para || "--"}`;
  let dilation = [
    specifics.dilatation || "--",
    specifics.effacement || "--",
    specifics.station || "--",
  ].join("/");
  let date = formatDateTimeWithoutSeconds(specifics.cervicalExamTime) || "--";
  return (
    <span>
      <span className="ega">{specifics.ega || "--"} •&nbsp;</span>
      {gp} •&nbsp;
      {dilation} @&nbsp;
      {date}
    </span>
  );
}
